<template>
    <div class="heart-bubble" id="heart-bubble">
      <div class="count" v-if="this.list.length > 0">+{{count}}</div>
    </div>
</template>
<script>
    export default {
        name: "heartBubble",
        props: {},
        data() {
            return {
                count:0,
                list:[],
            };
        },
        created() {

        },
        mounted() {
            
        },
        methods: {
            start(){
                this.count++;
                let heartBubble = document.getElementById("heart-bubble");
                let bubble = document.getElementsByClassName("bubble");
                this.draw();
                const timer = setTimeout(() => {
                    heartBubble.removeChild(bubble[0]);
                    this.list.splice(0,1);
                    if(this.list.length == 0){
                        this.count = 0;
                    }
                    clearTimeout(timer)
                }, 2000)
            },
            draw(){
                let heartBubble = document.getElementById("heart-bubble");
                const b =Math.floor(Math.random() * 6) + 1;
                const bl =Math.floor(Math.random() * 11) + 1; // bl1~bl11
                let divItem = document.createElement("div");
                divItem.className = `bubble b${b} bl${bl}`;
                heartBubble.appendChild(divItem);
                this.list.push(divItem);
            }
        }
    }
</script>
<style lang="scss" scoped>
@font-face {
  font-family: "ysbth";
  src: url("../assets/css/YouSheBiaoTiHei-2.ttf");
}
.count{
  text-align: center;
  font-family: "ysbth";
  font-size: 42px;
  background-image:-webkit-linear-gradient(bottom,red,yellow); 
  -webkit-background-clip:text; 
  -webkit-text-fill-color:transparent; 
  position: absolute;
  bottom: 0;
  left: -20px;
}
.heart-bubble {
  width: 100px;
  height: 200px;
  position: relative;
  background-color: transparent;
}
::v-deep .bubble {
  position: absolute;
  width: 40px;
  height: 40px;
  left: 30px;
  bottom: 0px;
  background-repeat: no-repeat;
  background-size: 100%;
  transform-origin: bottom;
}
::v-deep .b1 {
  background-image: url(../assets/images/heart1.png);
}
::v-deep .b2 {
  background-image: url(../assets/images/heart2.png);
}
::v-deep .b3 {
  background-image: url(../assets/images/heart3.png);
}
::v-deep .b4 {
  background-image: url(../assets/images/heart4.png);
}
::v-deep .b5 {
  background-image: url(../assets/images/heart5.png);
}
::v-deep .b6 {
  background-image: url(../assets/images/heart6.png);
}
::v-deep .bl1 {
  animation: bubble_1 3s linear 1 forwards,
    bubble_big_1 0.8s linear 1 forwards,
    bubble_y 3s linear 1 forwards;
}
::v-deep .bl2 {
  animation: bubble_2 3s linear 1 forwards,
    bubble_big_2 0.8s linear 1 forwards,
    bubble_y 3s linear 1 forwards;
}
::v-deep .bl3 {
  animation: bubble_3 3s linear 1 forwards,
    bubble_big_1 0.8s linear 1 forwards,
    bubble_y 3s linear 1 forwards;
}
::v-deep .bl4 {
  animation: bubble_4 3s linear 1 forwards,
    bubble_big_2 0.8s linear 1 forwards,
    bubble_y 3s linear 1 forwards;
}
::v-deep .bl5 {
  animation: bubble_5 3s linear 1 forwards,
    bubble_big_1 0.8s linear 1 forwards,
    bubble_y 3s linear 1 forwards;
}
::v-deep .bl6 {
  animation: bubble_6 3s linear 1 forwards,
    bubble_big_3 0.8s linear 1 forwards,
    bubble_y 3s linear 1 forwards;
}
::v-deep .bl7 {
  animation: bubble_7 3s linear 1 forwards,
    bubble_big_1 0.8s linear 1 forwards,
    bubble_y 3s linear 1 forwards;
}
::v-deep .bl8 {
  animation: bubble_8 3s linear 1 forwards,
    bubble_big_3 0.8s linear 1 forwards,
    bubble_y 3s linear 1 forwards;
}
::v-deep .bl9 {
  animation: bubble_9 3s linear 1 forwards,
    bubble_big_2 0.8s linear 1 forwards,
    bubble_y 3s linear 1 forwards;
}
::v-deep .bl10 {
  animation: bubble_10 3s linear 1 forwards,
    bubble_big_1 0.8s linear 1 forwards,
    bubble_y 3s linear 1 forwards;
}
::v-deep .bl11 {
  animation: bubble_11 3s linear 1 forwards,
    bubble_big_2 0.8s linear 1 forwards,
    bubble_y 3s linear 1 forwards;
}
@keyframes bubble_11 {
  0% {
  }
  25% {
    margin-left: -10px;
  }
  50% {
    margin-left: -10px;
  }
  100% {
    margin-left: -18px;
  }
}
@keyframes bubble_10 {
  0% {
  }
  25% {
    margin-left: -20px;
  }
  50% {
    margin-left: -20px;
  }
  100% {
    margin-left: -20px;
  }
}
@keyframes bubble_9 {
  0% {
  }
  25% {
    margin-left: 10px;
  }
  50% {
    margin-left: 10px;
  }
  100% {
    margin-left: 10px;
  }
}
@keyframes bubble_8 {
  0% {
  }
  25% {
    margin-left: 20px;
  }
  50% {
    margin-left: 20px;
  }
  100% {
    margin-left: 20px;
  }
}
@keyframes bubble_7 {
  0% {
  }
  25% {
    margin-left: 3px;
  }
  50% {
    margin-left: 1px;
  }
  75% {
    margin-left: 2px;
  }
  100% {
    margin-left: 3px;
  }
}
@keyframes bubble_6 {
  0% {
  }
  25% {
    margin-left: -3px;
  }
  50% {
    margin-left: -1px;
  }
  75% {
    margin-left: -2px;
  }
  100% {
    margin-left: -3px;
  }
}
@keyframes bubble_5 {
  0% {
  }
  25% {
    margin-left: 5px;
  }
  50% {
    margin-left: -5px;
  }
  75% {
    margin-left: -10px;
  }
  100% {
    margin-left: -20px;
  }
}
@keyframes bubble_4 {
  0% {
  }
  25% {
    margin-left: -5px;
  }
  50% {
    margin-left: -5px;
  }
  75% {
    margin-left: 20px;
  }
  100% {
    margin-left: 10px;
  }
}
@keyframes bubble_3 {
  0% {
  }
  25% {
    margin-left: -20px;
  }
  50% {
    margin-left: 10px;
  }
  75% {
    margin-left: 20px;
  }
  100% {
    margin-left: -10px;
  }
}
@keyframes bubble_2 {
  0% {
  }
  25% {
    margin-left: 20px;
  }
  50% {
    margin-left: 25px;
  }
  75% {
    margin-left: 10px;
  }
  100% {
    margin-left: 5px;
  }
}
@keyframes bubble_1 {
  0% {
  }
  25% {
    margin-left: -8px;
  }
  50% {
    margin-left: 8px;
  }
  75% {
    margin-left: -15px;
  }
  100% {
    margin-left: 15px;
  }
}
@keyframes bubble_big_1 {
  0% {
    transform: scale(0.3);
  }
  100% {
    transform: scale(1.2);
  }
}
@keyframes bubble_big_2 {
  0% {
    transform: scale(0.3);
  }
  100% {
    transform: scale(0.9);
  }
}
@keyframes bubble_big_3 {
  0% {
    transform: scale(0.3);
  }
  100% {
    transform: scale(0.6);
  }
}
@keyframes bubble_y {
  0% {
    margin-bottom: 0;
    opacity: 1;
  }
  25% {
    margin-bottom: 50px;
    opacity: 1;
  }
  50% {
    opacity: .5;
  }
  75% {
    opacity: .1;
  }
  100% {
    margin-bottom: 200px;
    opacity: 0;
  }
}
</style>
